import { render, staticRenderFns } from "./HighlightedText.vue?vue&type=template&id=612f7018&"
import script from "./HighlightedText.vue?vue&type=script&lang=js&"
export * from "./HighlightedText.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports